import { Apple, Dumbbell, Target } from "lucide-react";
import { HEALTH_COACH_TYPES } from "src/constants/common";
import { HealthCoachType } from "src/types/appointment.types";

const CoachProfile = ({
  coachKey,
  profilePicture,
}: {
  coachKey: HealthCoachType;
  profilePicture?: string;
}) => {
  const getProfilePic = (key: HealthCoachType) => {
    // TODO: Implement this function to get the profile picture of the coach later, just for now we are fallbacking to null and use icons.
    // const map = {
    //   nutritionist: "Nutritionist",
    //   physiotherapist: "Physiotherapist",
    //   psychoanalyst: "Success Coach",
    // };
    // return patientDetails?.hc_list?.find((hc: any) => hc.role === map[key])
    //   ?.profile_pic;
    return null;
  };

  const getFallbackIcon = (coachKey: HealthCoachType) => {
    switch (coachKey) {
      case HEALTH_COACH_TYPES.NUTRITIONIST:
        return <Apple className="w-5 h-5 text-[var(--app-primary)]" />;
      case HEALTH_COACH_TYPES.PSYCHOANALYST:
        return <Target className="w-5 h-5 text-[var(--app-primary)]" />;
      case HEALTH_COACH_TYPES.PHYSIOTHERAPIST:
        return <Dumbbell className="w-5 h-5 text-[var(--app-primary)]" />;
      default:
        return null;
    }
  };
  return (
    <>
      {(() => {
        const finalProfilePicture = profilePicture || getProfilePic(coachKey);
        return finalProfilePicture ? (
          <img
            src={finalProfilePicture}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            {getFallbackIcon(coachKey)}
          </div>
        );
      })()}
    </>
  );
};

export default CoachProfile;
